export function b64urlToBytes(s: string): Uint8Array<ArrayBuffer> {
  const pad = s.length % 4 === 0 ? '' : '='.repeat(4 - (s.length % 4));
  const bin = atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

export function bytesToB64url(bytes: ArrayBuffer | Uint8Array): string {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let bin = '';
  for (const b of view) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeCreationOptions(publicKey: PublicKeyCredentialCreationOptions): PublicKeyCredentialCreationOptions {
  return {
    ...publicKey,
    challenge: b64urlToBytes(publicKey.challenge as unknown as string),
    user: {
      ...publicKey.user,
      id: b64urlToBytes(publicKey.user.id as unknown as string),
    },
    excludeCredentials: (publicKey.excludeCredentials ?? []).map((c) => ({
      ...c,
      id: b64urlToBytes(c.id as unknown as string),
    })),
  };
}

export function decodeRequestOptions(publicKey: PublicKeyCredentialRequestOptions): PublicKeyCredentialRequestOptions {
  return {
    ...publicKey,
    challenge: b64urlToBytes(publicKey.challenge as unknown as string),
    allowCredentials: (publicKey.allowCredentials ?? []).map((c) => ({
      ...c,
      id: b64urlToBytes(c.id as unknown as string),
    })),
  };
}

export function encodeCredential(cred: Credential): unknown {
  if (!(cred instanceof PublicKeyCredential)) throw new Error('not a PublicKeyCredential');
  const r = cred.response as AuthenticatorAttestationResponse | AuthenticatorAssertionResponse;
  const isRegistration = 'attestationObject' in r;
  const response = isRegistration
    ? {
        clientDataJSON: bytesToB64url(r.clientDataJSON),
        attestationObject: bytesToB64url((r as AuthenticatorAttestationResponse).attestationObject),
      }
    : {
        clientDataJSON: bytesToB64url(r.clientDataJSON),
        authenticatorData: bytesToB64url((r as AuthenticatorAssertionResponse).authenticatorData),
        signature: bytesToB64url((r as AuthenticatorAssertionResponse).signature),
        userHandle: (r as AuthenticatorAssertionResponse).userHandle
          ? bytesToB64url((r as AuthenticatorAssertionResponse).userHandle!)
          : null,
      };
  return {
    id: cred.id,
    rawId: bytesToB64url(cred.rawId),
    type: cred.type,
    response,
    clientExtensionResults: cred.getClientExtensionResults(),
    authenticatorAttachment: cred.authenticatorAttachment,
  };
}